export default {
    home: "Home",
    product: "Products",
    apply: "Application",
    zlykkx:'Quality & Reliability',
    support: "Service",
    onlineClass:"Online class",
    tecArticles:"technical article",
    aboutUs: "About CIMO",
    introduce:'Company Introduction',
    news:"News and Information",
    contact:'Contact Us',
    xsydls:"Sales and agents",
    joinUs:"Join CIMO",
    LearnMore:"Learn more",
    ProductCenter:"Product Center",
    IndustryApplication:"Industry Application",
    CompanyProfile:"Company Profile",
    InvestmentPartners:"Investment Partners",
    ContactUs:"Contact Us",
    NewsCenter:"News Center",
    footer1:"Focus on High-Performance Analog Signal Chain Chip Design",
    BeijingOffice:"Beijing Office",
    BeijingAddress:"9th Floor, Tower A, Xueqing Jiachuang Building,Courtyard 10, Xueqing Road, Haidian District, Beijing",
    ChengduOffice:"Chengdu Office",
    ChengduAddress:"10th Floor, Unit 1, Building 1,Goodix Technology Mansion, No.10 Jitai Road,High-tech Zone, Chengdu",
    SalesInquiries:"Sales Inquiries",
    sales1:"(North China / Northwest / Southwest China)",
    sales2:"(East China / Central China)",
    sales3:"(South China)",
    sales4:"(Nationwide)",
    Email:"Email",
    Sales:"Sales",
    Recruitment:"Recruitment",
    service:"Service",
    FollowUs:"Follow Us",
    NewProducts:"New Products",
    ProductSelectionTable:"Product Selection Table",
    Filters:"Filters",
    SearchPart:"Search Part Number",
    Reset:"Reset",
      ProductInformation:"Product Information",
      Description:"Description",
      ProductVideo:"Product Video",
      Features:"Features",
      Applications:"Applications",
      OrderingGuide:"Ordering Guide",
      SalesInquiry:"Sales Inquiry",
      address:"Address",
      phone:"Phone",
      wechat:"WeChat",
      NewProductReleases:"New Product Releases",
      productDetail:"Product Details",

  }


// WEBPACK FOOTER //
// ./src/lang/en.js